import axios from './common/axios';

export default {
  canCheckout(params) {
    return axios
      .get(`/checkout/points-redemption/${params.product_id}/${params.sku_id}`)
      .then(function (res) {
        if (res.data.status === 'ng') {
          throw new Error(res.data.errors.general);
        }
        return res.data;
      });
  }
};
